'use es6';

import Immutable from 'immutable';
import { APP_INTEGRATIONS_RECEIVED } from '../actions/ActionTypes';
const EMPTY_SET = Immutable.OrderedSet();

const appIntegrations = (state = EMPTY_SET, action) => {
  switch (action.type) {
    case APP_INTEGRATIONS_RECEIVED:
      return Immutable.OrderedSet(action.payload.sort());

    default:
      return state;
  }
};

export default appIntegrations;